<template>
  <div class="manegeCenter_page">
    <div class="top_box">
      <el-row :gutter="20">
        <el-col :span="6">
          <div>
            <el-statistic
              group-separator=","
              :precision="2"
              :value="balance"
              title="我的预存款"
            ></el-statistic>
          </div>
        </el-col>
        <el-col :span="6">
          <!-- <div>
            <el-statistic
              group-separator=","
              :precision="2"
              :value="0"
              title="授信额度"
            ></el-statistic>
          </div> -->
        </el-col>
        <el-col :span="6">
          <div></div>
        </el-col>
        <el-col :span="6">
          <div></div>
        </el-col>
      </el-row>
    </div>
    <div class="btn_box">
      <el-descriptions title="用户信息" column="5">
        <el-descriptions-item label="今日下单"
          >{{ todayOrderNum }}条</el-descriptions-item
        >
        <el-descriptions-item label="待审核订单"
          >{{ verifyOrderNum }}条</el-descriptions-item
        >
        <el-descriptions-item label="已审核订单"
          >{{ verifyedOrderNum }}条</el-descriptions-item
        >
        <el-descriptions-item label="订单金额统计"
          >{{ orderPrice }}条</el-descriptions-item
        >
        <el-descriptions-item label="已取消订单"
          >{{ cancelOrderNum }}条</el-descriptions-item
        >
      </el-descriptions>
    </div>
    <div class="btn_h5_box">
      <el-descriptions title="用户信息" column="1">
        <el-descriptions-item label="今日下单"
          >{{ todayOrderNum }}条</el-descriptions-item
        >
        <el-descriptions-item label="待审核订单"
          >{{ verifyOrderNum }}条</el-descriptions-item
        >
        <el-descriptions-item label="已审核订单"
          >{{ verifyedOrderNum }}条</el-descriptions-item
        >
        <el-descriptions-item label="订单金额统计"
          >{{ orderPrice }}条</el-descriptions-item
        >
        <el-descriptions-item label="已取消订单"
          >{{ cancelOrderNum }}条</el-descriptions-item
        >
      </el-descriptions>
    </div>
  </div>
</template>

<script>
import { manegeCenterApi } from "../../api/index";
export default {
  data() {
    return {
      balance: 11.11, //我的预存款
      todayOrderNum: 0, //今日下单
      verifyOrderNum: 0, //待审核订单
      verifyedOrderNum: 0, //已审核订单
      orderPrice: 1.11, //订单金额统计 元
      cancelOrderNum: 1, //已取消订单
    };
  },
  created() {},
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      manegeCenterApi()
        .then((res) => {
          if (res.resultStatus) {
            this.balance = res.resultData.balance || 0;
            this.todayOrderNum = res.resultData.todayOrderNum || 0;
            this.verifyOrderNum = res.resultData.verifyOrderNum || 0;
            this.verifyedOrderNum = res.resultData.verifyedOrderNum || 0;
            this.orderPrice = res.resultData.orderPrice || 0;
            this.cancelOrderNum = res.resultData.cancelOrderNum || 0;
          } else {
            this.balance = 0;
            this.todayOrderNum = 0;
            this.verifyOrderNum = 0;
            this.verifyedOrderNum = 0;
            this.orderPrice = 0;
            this.cancelOrderNum = 0;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style lang="less">
.manegeCenter_page {
  width: 100%;
  height: 100%;
  border: 1px solid #e1e1e1;
  padding: 20px;
  box-sizing: border-box;
  @media screen and (min-width: 480px) {
    .top_box {
      margin-bottom: 20px;
      width: 50%;
    }
    .btn_box {
      margin: 10px 0px 0px 22px;
    }
    .btn_h5_box {
      display: none;
    }
  }
  @media only screen and (max-width: 480px) {
    .top_box {
      margin-bottom: 20px;
      width: 100%;
    }
    .btn_box {
      display: none;
    }
    .btn_h5_box {
      margin: 10px 0px 0px 22px;
    }
  }
}
</style>